module.exports = __webpack_public_path__ + "img/publis.86bb9709.svg";